<div class="container">
  <div class="payment-container">
    <div  class="modal" tabindex="-1" role="dialog" id="modErrPay" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body"><span class="text-danger text-center font-weight-bold">{{message}}</span></div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <div id="bill-page" class="payment-page mt-3">
      @if (qrCode.length==0) {
        <form [formGroup]="formCotisation">
          <div class="row justify-content-center"><img src="favicon.ico" class="img-fluid col-2 mb-3"></div>
          @if (!isQrCode) {
            <div class="form-group form-floating">
              <select formControlName="idPartner" name="idPartner" class="ml-2 mr-2 mt-2 form-select" (change)="checkBeginForm()">
                <option value="" selected>Choisir votre association</option>
                @for (asso of associations; track asso) {
                  <option value="{{asso.id}}">{{asso.name}}</option>
                }
              </select>
              <label>Choisir votre association</label>
            </div>
          }
          @if (isQrCode) {
            <input type="hidden" formControlName="idPartner" name="idPartner" value="{{idAssoc}}"/>
          }
          @if (isQrCode) {
            <div class="form-group form-floating">
              <input value ="{{assoc?.name}}"  class="ml-2 mr-2 mt-2 form-control" id ="assocName" [disabled]="true" >
              <label for="assocName">Nom de l'association</label>
            </div>
          }
          <div class="form-group form-floating">
            <input type="number"  class="ml-2 mr-2 mt-2 form-control" placeholder="Entrer le montant de votre cotisation" formControlName="amount" id="amount" (change)="checkBeginForm()">
            <label  for="amount">Entrer le montant de votre cotisation</label>
          </div>
          @if (isPayment) {
            <div>
              <div id="payment-page" class="payment-page">
                <div class="row justify-content-center gap-method">
                  <div class="col-3 payment-method border rounded d-flex flex-column justify-content-center mb-2 ml-3 p-2" style="width: auto;" data-method="card" (click)="onSelectPaymentMethod('card')">
                    <img class="img-fluid" src="images/visamaster.png" alt="carte" width="50">
                    <p class="mt-2 mb-0 text-center">Carte</p>
                  </div>
                  <div class="col-3 ml-2 payment-method border rounded d-flex flex-column justify-content-center mb-2" style="width: 135px;" data-method="omsn" (click)="onSelectPaymentMethod('OMSN')">
                    <img class="mt-4 img-fluid justify-content-center" src="images/omsn.webp" alt="orange money" width="50">
                    <p class="mt-1 ml-3">Orange money</p>
                  </div>
                  <div class="col-3 payment-method border rounded d-flex flex-column justify-content-center mb-2" data-method="wvsn" style="width: auto;" (click)="onSelectPaymentMethod('WVSN')">
                    <img class="mt-4 img-fluid justify-content-center" src="images/wave-logo.webp" alt="wave" width="50">
                    <p class="mt-1  ml-3">Wave</p>
                  </div>
                </div>
                @if (isWallet) {
                  <div class="row justify-content-center">
                    <div class="form-group form-floating col-sm-6">
                      <input type="tel"  class="ml-2 mr-2 mt-2 form-control " placeholder="Votre numero de téléphone" formControlName="phone" id="phone">
                      <label  for="phone">Votre numero de téléphone</label>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          <div class="d-grid gap-2 col-6 mx-auto mt-2">
            <button class="btn btn-success" (click)="createPayment()" [disabled]="!formCotisation.valid">Valider</button>
          </div>
        </form>
      }
    </div>

    @if (qrCode.length>0) {
      <div  class="row justify-content-center">
        <div class="d-flex justify-content-center" style="width: 300;">Scannez et payez </div>
        <div class="d-flex justify-content-center">
          <div class="d-block">
            <img class="img-fluid" src="images/omsn.webp" alt="orange money" width="120" height="50">
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <qrcode [qrdata]="qrCode" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
        </div>
      </div>
    }
  </div>
</div>


